import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import moment from 'moment';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  Chip,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  CircularProgress,
  Paper,
  makeStyles,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Checkbox,
  TextField,
  MenuItem,
  Menu,
  Tooltip,
} from '@material-ui/core';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import ReceiptIcon from '@material-ui/icons/Receipt';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CloseIcon from '@material-ui/icons/Close';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import VisibilityIcon from '@material-ui/icons/Visibility';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import GetAppIcon from '@material-ui/icons/GetApp';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import MarkunreadMailboxIcon from '@material-ui/icons/MarkunreadMailbox';
import html2pdf from 'html2pdf.js';
import InvoicePrintableContent from '../../../components/InvoicePrintableContent';

const useStyles = makeStyles((theme) => ({
  orangeFocused: {
    backgroundColor: "#FFFFFF",
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#FF7F27',
    },
    '& .MuiInputLabel-outlined.Mui-focused': {
      color: '#FF7F27',
    },
  },
  root: {
    background: "#f7faff",
    boxShadow: "0 6px 32px rgba(0,45,85,0.18)",
    borderRadius: 14,
  },
  card: {
    background: '#f7faff',
    borderRadius: 14,
  },
  cardContent: {
    background: '#f7faff',
    borderRadius: 14,
    padding: '12px 24px 24px 24px !important',
  },
  Button: {
    color: "#FFFFFF",
    backgroundColor: "#002D55",
    borderRadius: 18,
    border: 'none',
    boxShadow: 'none',
    padding: 'clamp(4px, 0.39vw, 6px) clamp(10px, 1.04vw, 16px)',
    marginRight: 'clamp(6px, 0.52vw, 8px)',
    fontSize: 'clamp(0.72rem, calc(2px + 0.722vw), 1.0rem)',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: "#fb741a",
    }
  },
  Button2: {
    transition: 'background 0.2s',
    backgroundColor: '#002D55',
    color: '#FFFF',
    borderRadius: 18,
    zIndex: 2,
    border: 'none',
    boxShadow: 'none',
    padding: 'clamp(4px, 0.39vw, 6px) clamp(10px, 1.04vw, 16px)',
    fontSize: 'clamp(0.68rem, calc(2px + 0.722vw), 0.95rem)',
    '&:hover': {
      backgroundColor: '#e6eaf0',
      color: '#F79500',
      fontWeight: 'bold',
      zIndex: 2,
    },
  },
  Button3: {
    transition: 'background 0.2s',
    backgroundColor: '#e6eaf0',
    color: '#002D55',
    fontWeight: 'bold',
    borderRadius: 18,
    zIndex: 2,
    border: 'none',
    boxShadow: 'none',
    padding: 'clamp(4px, 0.39vw, 6px) clamp(10px, 1.04vw, 16px)',
    fontSize: 'clamp(0.68rem, calc(2px + 0.722vw), 0.95rem)',
    '&:hover': {
      backgroundColor: '#e6eaf0',
      color: '#F79500',
      fontWeight: 'bold',
      zIndex: 2,
    },
  },
  bodyText: {
    color: "#666666",
    marginBottom: 'clamp(16px, 0.78vw, 24px)',
    fontSize: 'clamp(0.76rem, 0.81vw, 0.9375rem)',
  },
  cardHeaderTitle: {
    color: "#002D55",
    fontWeight: "bold",
    fontSize: 'clamp(0.88rem, 0.95vw, 1.125rem)',
  },
  cardHeaderRoot: {
    minHeight: 'clamp(42px, calc(24px + 1.45vw), 56px)',
    padding: 'clamp(8px, calc(1px + 0.55vw), 12px) clamp(10px, calc(2px + 0.625vw), 16px)',
    boxSizing: 'border-box',
    borderBottom: '2px solid #FF7F27',
    '& .MuiCardHeader-content': {
      overflow: 'hidden',
    },
    '& .MuiCardHeader-title': {
      fontSize: 'clamp(0.88rem, 0.95vw, 1.125rem)',
      fontWeight: 700,
      color: '#002D55',
      lineHeight: 1.2,
      paddingLeft: 5,
    },
  },
  statusChip: {
    backgroundColor: "#E0E0E0",
    color: "#666666",
    marginTop: 'clamp(6px, 0.52vw, 8px)',
    fontSize: 'clamp(0.625rem, 0.65vw, 0.75rem)',
  },
  statusChipActive: {
    backgroundColor: "#d4edda",
    color: "#155724",
    marginTop: 'clamp(6px, 0.52vw, 8px)',
    fontSize: 'clamp(0.625rem, 0.65vw, 0.75rem)',
  },
  closeIconButton: {
    backgroundColor: '#e6eaf0',
    color: '#002D55',
    fontWeight: 'bold',
    fontSize: 'clamp(0.68rem, calc(2px + 0.722vw), 0.95rem)',
    borderRadius: 12,
    border: 'none',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#e6eaf0',
      color: '#FF7F27',
      border: 'none',
      boxShadow: 'none',
    },
  },
  dialogPaper: {
    borderRadius: 18,
    overflow: 'hidden',
    boxShadow: '0 18px 40px rgba(0,45,85,0.18)',
  },
  dialogTitle: {
    borderBottom: '1px solid #eeeeee',
    padding: '16px 24px',
    backgroundColor: '#ffffff',
  },
  dialogTitleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  dialogTitleText: {
    flex: 1,
    color: '#002D55',
    fontWeight: 600,
    fontSize: 'clamp(0.95rem, calc(4px + 0.72vw), 1.15rem)',
    textTransform: 'uppercase',
  },
  closeButton: {
    color: '#64748B',
    padding: 6,
    '&:hover': {
      backgroundColor: '#edf5fc',
    },
  },
  downloadButton: {
    '&:focus': {
      backgroundColor: '#FF7F27',
    },
    '&:focus-visible': {
      backgroundColor: '#FF7F27',
    },
  },
  dialogContent: {
    padding: '24px !important',
    backgroundColor: '#e6eaf0',
    '&.MuiDialogContent-dividers': {
      borderTop: 'none',
      borderBottom: 'none',
    },
  },
  dialogContentFlush: {
    padding: '0 !important',
  },
  dialogPanel: {
    backgroundColor: '#f7faff',
    borderRadius: 18,
    padding: 16,
    border: '1px solid #dce8f5',
    boxShadow: '0 10px 24px rgba(0, 45, 85, 0.08)',
    [theme.breakpoints.down('sm')]: {
      borderRadius: 14,
      padding: 12,
    },
  },
  dialogSectionLabel: {
    fontSize: 12,
    color: '#666666',
    marginBottom: 10,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    [theme.breakpoints.down('sm')]: {
      fontSize: 'clamp(0.68rem, 1.04vw, 0.72rem)',
      marginBottom: 8,
    },
  },
  dialogActions: {
    padding: 16,
    gap: 8,
    justifyContent: 'flex-end',
    borderTop: '1px solid #eeeeee',
    backgroundColor: '#ffffff',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      padding: 12,
    },
  },
  dialogActionButton: {
    borderRadius: 50,
  },
}));

const SELECT_MENU_PROPS = {
  getContentAnchorEl: null,
  anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
  transformOrigin: { vertical: 'top', horizontal: 'left' },
  PaperProps: { style: { borderRadius: 14, marginTop: 8 } },
};
const BRAND_COLORS = {
  PRIMARY: '#002D55',
  ACCENT: '#fb741a',
  SUCCESS: '#4caf50',
  ERROR: '#d32f2f',
  WARNING: '#ff9800',
  INFO: '#2196f3',
  DISABLED: '#9e9e9e',
  TEXT_TERTIARY: '#666666',
  BORDER: '#e0e0e0',
};

const PaymentSubscription = ({ className, selectedPatient, headerTabs, headerTitle = 'Payment overview', ...rest }) => {
  const classes = useStyles();
  const token = useSelector((state) => state.auth.token);
  const user = useSelector((state) => state.auth.user);
  const backendBaseUrl = process.env.REACT_APP_BACKEND_URL || 'https://api.virtus-one.com';

  const [cardSaved, setCardSaved] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [invoices, setInvoices] = useState([]);
  const [loadingInvoices, setLoadingInvoices] = useState(false);
  const [appointments, setAppointments] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const [paymentPreference, setPaymentPreference] = useState('invoice');
  const [loadingPref, setLoadingPref] = useState(false);
  const [treatments, setTreatments] = useState([]);
  const [requestAutopayDialogOpen, setRequestAutopayDialogOpen] = useState(false);
  const [requestingAutopay, setRequestingAutopay] = useState(false);
  const [autopayRequestMessage, setAutopayRequestMessage] = useState('');
  const [invoicePreviewOpen, setInvoicePreviewOpen] = useState(false);
  const [selectedInvoiceForPreview, setSelectedInvoiceForPreview] = useState(null);
  const [invoicePreviewLoading, setInvoicePreviewLoading] = useState(false);
  const [careProviderInfo, setCareProviderInfo] = useState(null);
  const [invoiceIssuerNameMode, setInvoiceIssuerNameMode] = useState('staff');
  const [invoiceCustomIssuerName, setInvoiceCustomIssuerName] = useState('');
  const [invoiceActionAnchorEl, setInvoiceActionAnchorEl] = useState(null);
  const [invoiceActionLoading, setInvoiceActionLoading] = useState(false);
  const [invoiceActionNotice, setInvoiceActionNotice] = useState('');
  const [invoiceActionError, setInvoiceActionError] = useState('');
  const [invoiceActionsAnchorEl, setInvoiceActionsAnchorEl] = useState(null);
  const [invoiceActionsInvoice, setInvoiceActionsInvoice] = useState(null);
  const [invoiceActionsLoading, setInvoiceActionsLoading] = useState(false);
  const [selectedBillingRows, setSelectedBillingRows] = useState([]);
  const [billDialogOpen, setBillDialogOpen] = useState(false);
  const [billingGroupMode, setBillingGroupMode] = useState('group_by_payer');
  const [billDialogError, setBillDialogError] = useState('');
  const [billDialogLoading, setBillDialogLoading] = useState(false);
  const [billPreviewOpen, setBillPreviewOpen] = useState(false);
  const [billPreviewInvoices, setBillPreviewInvoices] = useState([]);
  const [billPreviewLoading, setBillPreviewLoading] = useState(false);

  const patientId = selectedPatient?.user_id || selectedPatient?.id || selectedPatient?.user?.id || selectedPatient?.patient_id || '';
  const isPatientSelf = Boolean(user?.id && patientId && String(user.id) === String(patientId));

  const getAppointmentPatientId = (appointment) => {
    if (!appointment) return '';
    if (appointment.patient?.id) return appointment.patient.id;
    return appointment.patient_id || appointment.patient || appointment.user_id || '';
  };

  // ─── Utility Functions (from patient version) ────────────────────────────────
  const denormalizeInsuranceProvider = (value) => {
    if (!value) return '—';
    const normalized = String(value).trim().toLowerCase();
    const map = {
      united_healthcare: 'United Healthcare',
      aetna: 'Aetna',
      cigna: 'Cigna',
      anthem: 'Anthem',
      humana: 'Humana',
      kaiser: 'Kaiser Permanente',
      private: 'Private Insurance',
      other: 'Other',
    };
    return map[normalized] || value;
  };

  const denormalizePlanType = (value) => {
    if (!value) return '—';
    const normalized = String(value).trim().toLowerCase();
    const map = {
      ppo: 'PPO',
      hmo: 'HMO',
      epo: 'EPO',
      pos: 'POS',
      private: 'Private',
      other: 'Other',
    };
    return map[normalized] || value;
  };

  const getAppointmentLabel = (appointmentType) => {
    if (!appointmentType) return 'Appointment';
    const normalized = appointmentType.toLowerCase();
    if (normalized.includes('video')) return 'Video Consultation';
    if (normalized.includes('follow')) return 'Follow-up';
    if (normalized.includes('assessment')) return 'Assessment';
    if (normalized.includes('treatment')) return 'Treatment';
    if (normalized.includes('in_person')) return 'In-Person';
    return appointmentType.replace(/_/g, ' ');
  };

  const lineMatchesAppointment = (line, appointmentId) => {
    const directId = line?.appointment?.id || line?.appointment || line?.appointment_id;
    return String(directId) === String(appointmentId);
  };

  const reversedInvoiceStatuses = new Set(['accredited', 'refunded', 'cancelled']);

  const isOpenInvoice = (invoice) => {
    const status = String(invoice?.status || '').toLowerCase();
    return Boolean(status) && status !== 'paid' && !reversedInvoiceStatuses.has(status);
  };

  const getAppointmentInvoice = (appointmentId) => {
    const matchingInvoices = invoices.filter((inv) => (
      inv.line_items && inv.line_items.some((line) => lineMatchesAppointment(line, appointmentId))
    ));

    if (matchingInvoices.length === 0) {
      return null;
    }

    return matchingInvoices.find((inv) => String(inv.status || '').toLowerCase() === 'paid')
      || matchingInvoices.find((inv) => !reversedInvoiceStatuses.has(String(inv.status || '').toLowerCase()))
      || matchingInvoices[0];
  };

  const getAppointmentByInvoice = (invoiceId) => (
    appointments.find((appt) => {
      const linkedInvoice = getAppointmentInvoice(appt.id);
      return linkedInvoice && String(linkedInvoice.id) === String(invoiceId);
    }) || null
  );

  const isAppointmentPaid = (appointment, invoice) => {
    if (invoice) {
      return invoice.status === 'paid';
    }
    if (appointment.billing_status === 'invoiced' || appointment.billing_status === 'billed') {
      return false;
    }
    return appointment.payment_status === 'paid';
  };

  const isBilledUnpaidAppointment = (appointment, invoice) => {
    if (appointment.status === 'cancelled' || appointment.status === 'canceled') {
      return false;
    }

    if (invoice) {
      const settledStatuses = new Set(['paid', 'cancelled', 'accredited', 'inkasso']);
      return !settledStatuses.has(invoice.status);
    }

    const billedStatuses = new Set(['invoiced', 'billed']);
    return billedStatuses.has(appointment.billing_status) && appointment.payment_status !== 'paid';
  };

  const isBilledPaidAppointment = (appointment, invoice) => {
    if (appointment.status === 'cancelled' || appointment.status === 'canceled') {
      return false;
    }

    if (invoice) {
      return invoice.status === 'paid';
    }

    return appointment.payment_status === 'paid';
  };

  const getAppointmentBillingChip = (appointment, invoice) => {
    const makeChip = (label, backgroundColor, color) => ({ label, style: { backgroundColor, color } });

    if (invoice) {
      switch (invoice.status) {
        case 'paid':
          return makeChip('Paid', '#E8F5E9', '#2E7D32');
        case 'accredited':
          return makeChip('Accredited', '#E3F2FD', '#1565C0');
        case 'inkasso':
          return makeChip('Inkasso', '#FFEBEE', '#C62828');
        case 'challenged':
          return makeChip('Challenged', '#FFF3E0', '#E65100');
        case 'reminder_1':
          return makeChip('Billed (1st reminder)', '#FFF3E0', '#F57C00');
        case 'reminder_2':
          return makeChip('Billed (2nd reminder)', '#FFE0B2', '#EF6C00');
        case 'reminder_3':
          return makeChip('Billed (3rd reminder)', '#FFCCBC', '#E64A19');
        case 'draft':
        case 'sent':
        case 'reopened':
        case 'viewed':
        case 'accepted':
        case 'overdue':
        case 'partially_paid':
          return makeChip('Billed (payment due)', '#FFF3E0', '#F57C00');
        default:
          return makeChip('Billed (payment due)', '#FFF3E0', '#F57C00');
      }
    }

    if (appointment.payment_status === 'paid') {
      return makeChip('Paid', '#E8F5E9', '#2E7D32');
    }
    if (appointment.billing_status === 'unbilled' || appointment.billing_status === 'bookable') {
      return makeChip('Unbilled', '#EEEEEE', '#666');
    }
    if (appointment.billing_status === 'invoiced') {
      return makeChip('Billed (payment due)', '#FFF3E0', '#F57C00');
    }

    return makeChip('Unbilled', '#EEEEEE', '#666');
  };

  const getAppointmentStatusChip = (appointment) => {
    const makeChip = (label, backgroundColor, color) => ({ label, style: { backgroundColor, color } });
    const status = appointment.status?.toLowerCase() || '';

    if (status === 'cancelled' || status === 'canceled' || status === 'no_show' || status === 'no-show') {
      return makeChip('Cancelled', '#C62828', '#fff');
    }
    const isPast = moment(appointment.start_datetime).isBefore(moment());
    if (isPast) {
      return makeChip('Completed', '#2E7D32', '#fff');
    }
    return makeChip('Scheduled', '#1565C0', '#fff');
  };

  function groupAppointmentsByMonth(items) {
    const groups = {};
    items.forEach((item) => {
      const date = new Date(item.start_datetime);
      const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
      const monthName = date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
      if (!groups[key]) {
        groups[key] = { key, monthName, items: [] };
      }
      groups[key].items.push(item);
    });
    return Object.values(groups).sort((a, b) => b.key.localeCompare(a.key));
  }

  function groupInvoicesByMonth(items) {
    const groups = {};
    items.forEach((item) => {
      const sourceDate = item.paid_date || item.payment_received_date || item.invoice_date || item.created;
      const date = new Date(sourceDate);
      const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
      const monthName = date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
      if (!groups[key]) {
        groups[key] = { key, monthName, items: [] };
      }
      groups[key].items.push(item);
    });
    return Object.values(groups).sort((a, b) => b.key.localeCompare(a.key));
  }

  const formatDate = (date) => {
    const d = new Date(date);
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  const formatTime = (date) => {
    const d = new Date(date);
    const pad = (n) => String(n).padStart(2, '0');
    return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
  };

  const getCourseName = (treatmentId) => {
    if (!treatmentId) return '—';
    const treatment = treatments.find(t => String(t.id) === String(treatmentId));
    return treatment?.name || treatment?.diagnosis?.diagnosis || '—';
  };

  const getAppointmentPayer = (appointment) => {
    const payerValue = String(
      appointment?.payer || appointment?.billing_payer || appointment?.payment_responsibility || ''
    ).toLowerCase();
    const insurancePaid = appointment?.insurance_paid === true;
    const insurancePayer = insurancePaid || payerValue === 'insurance' || payerValue === 'insurer';

    if (insurancePayer) {
      return {
        label: 'Insurance',
        style: {
          backgroundColor: '#E3F2FD',
          color: '#1565C0',
          fontWeight: 600,
          fontSize: 11,
        },
      };
    }

    return {
      label: 'Patient',
      style: {
        backgroundColor: '#9E9E9E',
        color: '#fff',
        fontWeight: 600,
        fontSize: 11,
      },
    };
  };

  const getInvoiceIssuerName = (invoiceLike) => {
    const clinicBusinessName = (
      careProviderInfo?.name_business ||
      invoiceLike?.care_provider_name ||
      'Clinic'
    );
    const staffName = (invoiceLike?.staff_member_name || '').trim();
    const isStaffSubcontractor = String(invoiceLike?.billing_type || '').toLowerCase() === 'staff_subcontractor';

    if (!isStaffSubcontractor) {
      return clinicBusinessName;
    }

    if (invoiceIssuerNameMode === 'custom' && String(invoiceCustomIssuerName || '').trim()) {
      return String(invoiceCustomIssuerName).trim();
    }
    if (invoiceIssuerNameMode === 'clinic') {
      return clinicBusinessName;
    }
    return staffName || clinicBusinessName;
  };

  const toTitleCase = (value = '') => String(value || '')
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (character) => character.toUpperCase());

  const getInvoiceStatusChip = (status) => {
    const normalizedStatus = String(status || 'unbilled').toLowerCase();
    const chip = {
      label: toTitleCase(normalizedStatus) || 'Unbilled',
      backgroundColor: '#E0E0E0',
      color: '#666666',
    };

    if (normalizedStatus === 'paid') {
      chip.label = 'Paid';
      chip.backgroundColor = '#E8F5E9';
      chip.color = '#2E7D32';
      return chip;
    }

    if (normalizedStatus === 'accredited') {
      chip.label = 'Accredited';
      chip.backgroundColor = '#E3F2FD';
      chip.color = '#1565C0';
      return chip;
    }

    if (normalizedStatus === 'refunded' || normalizedStatus === 'cancelled') {
      chip.label = toTitleCase(normalizedStatus);
      chip.backgroundColor = '#FFEBEE';
      chip.color = '#C62828';
      return chip;
    }

    if (normalizedStatus === 'inkasso') {
      chip.label = 'Inkasso';
      chip.backgroundColor = '#FFEBEE';
      chip.color = '#C62828';
      return chip;
    }

    if (
      normalizedStatus === 'draft'
      || normalizedStatus === 'sent'
      || normalizedStatus === 'reopened'
      || normalizedStatus === 'viewed'
      || normalizedStatus === 'accepted'
      || normalizedStatus === 'challenged'
      || normalizedStatus === 'partially_paid'
      || normalizedStatus === 'overdue'
      || normalizedStatus === 'reminder_1'
      || normalizedStatus === 'reminder_2'
      || normalizedStatus === 'reminder_3'
      || normalizedStatus === 'unbilled'
    ) {
      chip.label = normalizedStatus === 'unbilled' ? 'Unbilled' : toTitleCase(normalizedStatus);
      chip.backgroundColor = '#FFF3E0';
      chip.color = '#F57C00';
      return chip;
    }

    return chip;
  };

  const isAccreditableInvoice = (invoice) => {
    const status = String(invoice?.status || '').toLowerCase();
    return ['paid', 'partially_paid'].includes(status);
  };

  const getNextReminderTypeForInvoice = (invoice) => {
    const status = String(invoice?.status || '').toLowerCase();

    if (status === 'reminder_1') {
      return '2nd';
    }

    if (status === 'reminder_2') {
      return '3rd';
    }

    if (status === 'reminder_3') {
      return 'inkasso';
    }

    return '1st';
  };

  const handleOpenInvoiceActions = (event, invoice) => {
    setInvoiceActionsAnchorEl(event.currentTarget);
    setInvoiceActionsInvoice(invoice);
  };

  const handleCloseInvoiceActions = () => {
    if (invoiceActionsLoading) {
      return;
    }
    setInvoiceActionsAnchorEl(null);
    setInvoiceActionsInvoice(null);
  };

  const refreshInvoiceDataAfterAction = async (invoiceId) => {
    await loadInvoices();
    if (selectedInvoiceForPreview?.id && String(selectedInvoiceForPreview.id) === String(invoiceId)) {
      await handleViewInvoice(invoiceId);
    }
  };

  const handleInvoiceBulkAction = async (action) => {
    const invoice = invoiceActionsInvoice;
    if (!invoice?.id) {
      return;
    }

    if (action === 'accredit') {
      const confirmed = window.confirm(`Accredit invoice #${invoice.invoice_number || invoice.id}? This will create a credit note and reopen the source invoice when applicable.`);
      if (!confirmed) {
        return;
      }
    }

    if (action === 'send_reminder') {
      const confirmed = window.confirm(`Send a reminder for invoice #${invoice.invoice_number || invoice.id}?`);
      if (!confirmed) {
        return;
      }
    }

    setInvoiceActionsLoading(true);
    setErrorMessage('');
    setInvoiceActionNotice('');
    setInvoiceActionError('');

    try {
      const payload = {
        invoice_ids: [invoice.id],
        action,
      };

      if (action === 'accredit') {
        payload.patient_has_paid_balance = false;
        payload.transfer_to_patient_balance = false;
      }

      if (action === 'send_reminder') {
        payload.reminder_type = getNextReminderTypeForInvoice(invoice);
      }

      const response = await fetch(`${backendBaseUrl}/api/calendar/billing-actions/invoice-bulk/`, {
        method: 'POST',
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const responseData = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(responseData.error || responseData.detail || `Failed to ${action.replace('_', ' ')} invoice`);
      }

      await refreshInvoiceDataAfterAction(invoice.id);

      if (action === 'accredit') {
        setInvoiceActionNotice(`Invoice #${invoice.invoice_number || invoice.id} accredited successfully.`);
      } else if (action === 'send_reminder') {
        const reminderType = getNextReminderTypeForInvoice(invoice);
        setInvoiceActionNotice(
          reminderType === 'inkasso'
            ? `Invoice #${invoice.invoice_number || invoice.id} marked as inkasso.`
            : `Invoice #${invoice.invoice_number || invoice.id} marked as ${reminderType} reminder.`
        );
      }
    } catch (error) {
      const message = error.message || `Failed to ${action.replace('_', ' ')} invoice`;
      setErrorMessage(message);
      setInvoiceActionError(message);
    } finally {
      setInvoiceActionsLoading(false);
      handleCloseInvoiceActions();
    }
  };

  // ─── Data Loading ─────────────────────────────────────────────────────────────
  const loadCardStatus = async () => {
    if (!token || !patientId) return;
    setIsLoading(true);
    setErrorMessage('');
    try {
      const response = await fetch(`${backendBaseUrl}/api/stripe/customer/?patient=${patientId}`, {
        headers: {
          'Authorization': `Token ${token}`,
        },
      });
      if (!response.ok) {
        const text = await response.text();
        throw new Error(text || `Failed to load card status (${response.status})`);
      }
      const data = await response.json();
      setCardSaved(!!data.has_payment_method);
    } catch (error) {
      console.error('Card status load error:', error);
      setErrorMessage('Unable to load card status.');
    } finally {
      setIsLoading(false);
    }
  };

  const loadInvoices = async () => {
    if (!token || !patientId) return;
    setLoadingInvoices(true);
    try {
      const response = await fetch(`${backendBaseUrl}/api/invoices/?patient_id=${encodeURIComponent(patientId)}`, {
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        const text = await response.text();
        throw new Error(text || `Failed to load invoices (${response.status})`);
      }
      const data = await response.json();
      setInvoices(Array.isArray(data) ? data : (data.invoices || data.results || []));
    } catch (error) {
      console.error('Invoices load error:', error);
      setInvoices([]);
    } finally {
      setLoadingInvoices(false);
    }
  };

  const loadCareProviderInfo = async () => {
    if (!token) return;
    try {
      const response = await fetch(`${backendBaseUrl}/api/profile/careprovider/`, {
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) return;
      const data = await response.json();
      if (data?.has_care_provider) {
        setCareProviderInfo(data);
      }
    } catch (error) {
      console.error('Care provider load error:', error);
    }
  };

  const handleViewInvoice = async (invoiceId) => {
    if (!invoiceId) return;
    try {
      setInvoicePreviewLoading(true);
      const response = await fetch(`${backendBaseUrl}/api/calendar/invoices/${invoiceId}/`, {
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        throw new Error(`Failed to load invoice (${response.status})`);
      }
      const data = await response.json();
      setSelectedInvoiceForPreview(data);
      setInvoicePreviewOpen(true);
    } catch (error) {
      console.error('Invoice detail load error:', error);
      alert('Unable to load invoice details.');
    } finally {
      setInvoicePreviewLoading(false);
    }
  };

  useEffect(() => {
    if (!token || !patientId) {
      setAppointments([]);
      setInvoices([]);
      setTreatments([]);
      return;
    }

    let mounted = true;

    // Fetch payment preference
    (async () => {
      try {
        setLoadingPref(true);
        const res = await fetch(`${backendBaseUrl}/api/profile/payment-preference/?patient=${patientId}`, {
          headers: { 'Authorization': `Token ${token}` }
        });
        if (!mounted) return;
        if (res.ok) {
          const data = await res.json();
          setPaymentPreference(data.preference || 'invoice');
        }
      } catch (e) {
        console.error('Error loading preference:', e);
      } finally {
        if (mounted) setLoadingPref(false);
      }
    })();

    // Fetch appointments and treatments
    (async () => {
      try {
        setLoadingData(true);

        // Fetch appointments
        const apptRes = await fetch(`${backendBaseUrl}/api/calendar/appointments/?patient_id=${encodeURIComponent(patientId)}`, {
          headers: { 'Authorization': `Token ${token}` }
        });
        
        if (apptRes.ok && mounted) {
          const apptData = await apptRes.json();
          const apptArray = apptData.appointments || (Array.isArray(apptData) ? apptData : apptData.results || []);
          setAppointments(
            apptArray.filter((appointment) => String(getAppointmentPatientId(appointment)) === String(patientId))
          );
        }

        // Fetch treatments
        const treatRes = await fetch(`${backendBaseUrl}/treatment/user/treatments/?patient=${patientId}`, {
          headers: { 'Authorization': `Token ${token}` }
        });
        if (treatRes.ok && mounted) {
          const treatData = await treatRes.json();
          const treatArray = Array.isArray(treatData) ? treatData : treatData.treatments || treatData.results || [];
          setTreatments(treatArray);
        }
      } catch (e) {
        console.error('Error loading data:', e);
      } finally {
        if (mounted) setLoadingData(false);
      }
    })();

    loadCardStatus();
    loadInvoices();
    loadCareProviderInfo();

    return () => { mounted = false; };
  }, [patientId, token]);

  const hasMethods = cardSaved;

  // Calculate stats
  const unpaidInvoices = invoices.filter((inv) => isOpenInvoice(inv));
  const paidInvoices = invoices.filter(inv => inv.status === 'paid');
  const challengedInvoices = invoices.filter(inv => inv.status === 'challenged');
  const paidInvoicesByMonth = groupInvoicesByMonth(paidInvoices);

  const now = new Date();
  const upcomingAppointments = appointments.filter((appt) => new Date(appt.start_datetime) >= now);
  const pastAppointments = appointments.filter((appt) => new Date(appt.start_datetime) < now);
  
  const paidCount = pastAppointments.filter((appt) => {
    const invoice = getAppointmentInvoice(appt.id);
    return isBilledPaidAppointment(appt, invoice);
  }).length;

  const unpaidCount = pastAppointments.filter((appt) => {
    const invoice = getAppointmentInvoice(appt.id);
    return isBilledUnpaidAppointment(appt, invoice);
  }).length;

  const pastAppointmentsByMonth = groupAppointmentsByMonth(pastAppointments);

  // ─── Admin Billing Portal Handler (opens admin's own portal) ─────────────────
  const handleBillingPortal = async () => {
    try {
      const res = await fetch(`${backendBaseUrl}/api/profile/billing/portal-session/`, { 
        method: 'POST',
        headers: { 'Authorization': `Token ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        if (data.url) window.open(data.url, '_blank');
      } else {
        alert('Failed to open billing portal');
      }
    } catch (e) {
      console.error('Billing portal error:', e);
      alert('Could not open billing portal');
    }
  };

  // ─── Request Autopay Handler ─────────────────────────────────────────────────
  const handleRequestAutopay = async () => {
    if (!token || !patientId) {
      setAutopayRequestMessage('Error: Missing patient or authentication info');
      return;
    }

    setRequestingAutopay(true);
    setAutopayRequestMessage('');

    try {
      const response = await fetch(
        `${backendBaseUrl}/api/profile/autopay/request/`,
        {
          method: 'POST',
          headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            patient_id: patientId,
          }),
        }
      );

      if (!response.ok) {
        const text = await response.text();
        throw new Error(text || `Failed to request autopay (${response.status})`);
      }

      const data = await response.json();
      setAutopayRequestMessage('success');
      // Close dialog after success
      setTimeout(() => {
        setRequestAutopayDialogOpen(false);
        setAutopayRequestMessage('');
      }, 1500);
    } catch (error) {
      console.error('Request autopay error:', error);
      setAutopayRequestMessage(`error: ${error.message || 'Unable to send autopay request'}`);
    } finally {
      setRequestingAutopay(false);
    }
  };

  const cpAddress = careProviderInfo?.address || careProviderInfo?.street || '';
  const cpPostalCode = careProviderInfo?.postal_code || '';
  const cpCity = careProviderInfo?.city || '';
  const cpPhone = careProviderInfo?.phoneNumber_CareProvider || careProviderInfo?.phone || '';
  const cpEmail = careProviderInfo?.email_CareProvider || careProviderInfo?.email_contactPerson || '';

  const handleDownloadInvoicePDF = () => {
    if (!selectedInvoiceForPreview) return;
    const element = document.getElementById('invoice-printable-content');
    if (!element) return;
    const opt = {
      margin: 10,
      filename: `Invoice_${selectedInvoiceForPreview.invoice_number || selectedInvoiceForPreview.id}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { orientation: 'portrait', unit: 'mm', format: 'a4' },
    };
    html2pdf().set(opt).from(element).save();
  };

  const billablePastAppointments = pastAppointments.filter((appt) => String(appt?.billing_status || '').toLowerCase() === 'unbilled');

  const billablePastAppointmentIds = billablePastAppointments.map((appt) => String(appt.id));
  const selectedBillableAppointmentIds = selectedBillingRows.filter((appointmentId) => billablePastAppointmentIds.includes(String(appointmentId)));

  const handleToggleBillingRowSelected = (appointmentId) => {
    const normalizedId = String(appointmentId);
    if (!billablePastAppointmentIds.includes(normalizedId)) return;
    setSelectedBillingRows((previous) => (
      previous.some((item) => String(item) === normalizedId)
        ? previous.filter((item) => String(item) !== normalizedId)
        : [...previous, normalizedId]
    ));
  };

  const handleToggleSelectAllUnbilled = () => {
    setSelectedBillingRows((previous) => (
      previous.length === billablePastAppointmentIds.length ? [] : [...billablePastAppointmentIds]
    ));
  };

  const openBillDialogForAppointments = (appointmentIds) => {
    const normalizedIds = [...new Set((appointmentIds || []).map((id) => String(id)))].filter((id) => billablePastAppointmentIds.includes(id));
    if (normalizedIds.length === 0) {
      setBillDialogError('Select at least one unbilled past appointment.');
      setBillDialogOpen(true);
      return;
    }
    setSelectedBillingRows(normalizedIds);
    setBillDialogError('');
    setBillingGroupMode('group_by_payer');
    setBillDialogOpen(true);
  };

  const handleBillSelectedAppointments = () => {
    openBillDialogForAppointments(selectedBillableAppointmentIds);
  };

  const handleBillAllUnbilledAppointments = () => {
    openBillDialogForAppointments(billablePastAppointmentIds);
  };

  const handlePreviewBeforeBill = () => {
    if (selectedBillableAppointmentIds.length === 0) {
      setBillDialogError('Select at least one unbilled past appointment.');
      return;
    }
    const selectedAppts = billablePastAppointments.filter((appt) =>
      selectedBillableAppointmentIds.includes(String(appt.id))
    );
    const groups = {};
    selectedAppts.forEach((appt) => {
      const payerRaw = String(appt.payer_type || appt.payer || 'patient').toLowerCase();
      const isInsurance = payerRaw === 'insurance';
      const patientName = selectedPatient?.name
        || [selectedPatient?.user?.first_name, selectedPatient?.user?.last_name].filter(Boolean).join(' ').trim()
        || 'Patient';
      const key = billingGroupMode === 'single'
        ? String(appt.id)
        : `${isInsurance ? 'insurance' : 'patient'}|${patientName}`;
      if (!groups[key]) {
        groups[key] = {
          payer: isInsurance ? 'insurance' : 'patient',
          patient: patientName,
          rows: [],
          total: 0,
          patientPortion: 0,
          insurancePortion: 0,
        };
      }
      const total = parseFloat(appt.booked_price || 0);
      const patientPortion = parseFloat(appt.patient_out_of_pocket_amount || 0);
      const insurancePortion = parseFloat(appt.insurance_covered_amount || 0);
      let resolvedPatient = patientPortion;
      let resolvedInsurance = insurancePortion;
      if (resolvedPatient === 0 && resolvedInsurance === 0 && total > 0) {
        if (isInsurance) { resolvedInsurance = total; } else { resolvedPatient = total; }
      }
      groups[key].rows.push({
        ...appt,
        resolvedPatientPortion: resolvedPatient,
        resolvedInsurancePortion: resolvedInsurance,
        resolvedTotal: total,
      });
      groups[key].total += total;
      groups[key].patientPortion += resolvedPatient;
      groups[key].insurancePortion += resolvedInsurance;
    });
    setBillPreviewInvoices(Object.values(groups));
    setBillDialogOpen(false);
    setBillPreviewOpen(true);
  };

  const handleConfirmBillAfterPreview = async () => {
    if (selectedBillableAppointmentIds.length === 0) {
      return;
    }
    setBillPreviewLoading(true);
    setBillDialogError('');
    setInvoiceActionNotice('');
    setInvoiceActionError('');
    try {
      const baseUrl = process.env.REACT_APP_BACKEND_URL || 'https://api.virtus-one.com';
      const response = await fetch(`${baseUrl}/api/calendar/billing-actions/bill-selected/`, {
        method: 'POST',
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          appointment_ids: selectedBillableAppointmentIds,
          mode: billingGroupMode,
          billing_type: 'clinic',
        }),
      });
      const responseData = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(responseData.error || responseData.detail || 'Failed to bill selected appointments');
      }
      setSelectedBillingRows([]);
      setBillPreviewOpen(false);
      setBillPreviewInvoices([]);
      setInvoiceActionNotice(responseData.message || `Billed ${selectedBillableAppointmentIds.length} appointment${selectedBillableAppointmentIds.length === 1 ? '' : 's'}.`);
      await loadInvoices();
      if (responseData?.invoices?.length === 1) {
        await handleViewInvoice(responseData.invoices[0].id);
      }
    } catch (error) {
      setBillDialogError(error.message || 'Failed to bill selected appointments');
      setBillPreviewOpen(false);
      setBillDialogOpen(true);
    } finally {
      setBillPreviewLoading(false);
    }
  };

  const handleConfirmBillSelectedAppointments = () => {
    handlePreviewBeforeBill();
  };

  const renderInvoiceStatsTable = (items, emptyMessage, rowBorderColor) => (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow style={{ backgroundColor: '#F0F8FF' }}>
            <TableCell style={{ fontWeight: 600, color: '#002D55' }}>Date & Time</TableCell>
            <TableCell style={{ fontWeight: 600, color: '#002D55' }}>Course</TableCell>
            <TableCell style={{ fontWeight: 600, color: '#002D55' }}>Service</TableCell>
            <TableCell style={{ fontWeight: 600, color: '#002D55' }}>Staff</TableCell>
            <TableCell style={{ fontWeight: 600, color: '#002D55' }}>Payer</TableCell>
            <TableCell style={{ fontWeight: 600, color: '#002D55' }}>Amount</TableCell>
            <TableCell style={{ fontWeight: 600, color: '#002D55' }}>Invoice</TableCell>
            <TableCell style={{ fontWeight: 600, color: '#002D55' }} align="center">Status</TableCell>
            <TableCell style={{ fontWeight: 600, color: '#002D55' }} align="center">Payment</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.length > 0 ? (
            items.map((invoice) => {
              const appointment = getAppointmentByInvoice(invoice.id);
              const statusChip = appointment ? getAppointmentStatusChip(appointment) : getInvoiceStatusChip(invoice.status);
              const billingChip = getAppointmentBillingChip(appointment, invoice);
              const payerChip = appointment
                ? getAppointmentPayer(appointment)
                : {
                    label: String(invoice.recipient_type || '').toLowerCase() === 'insurance' ? 'Insurance' : 'Patient',
                    style: {
                      backgroundColor: String(invoice.recipient_type || '').toLowerCase() === 'insurance' ? '#E3F2FD' : '#9E9E9E',
                      color: String(invoice.recipient_type || '').toLowerCase() === 'insurance' ? '#1565C0' : '#FFFFFF',
                      fontWeight: 600,
                      fontSize: 11,
                    },
                  };
              const invoiceDateValue = appointment?.start_datetime || invoice.invoice_date || invoice.created;
              const invoiceDisplayAmount = invoice.total_amount ?? invoice.total ?? 0;

              return (
                <TableRow
                  key={invoice.id}
                  style={{ borderLeft: `3px solid ${rowBorderColor}` }}
                >
                  <TableCell>
                    <Typography style={{ fontWeight: 600, fontSize: 'clamp(0.72rem, 0.76vw, 0.875rem)' }}>
                      {invoiceDateValue ? formatDate(invoiceDateValue) : '—'}
                    </Typography>
                    <Typography style={{ fontSize: 'clamp(0.625rem, 0.65vw, 0.75rem)', color: '#666' }}>
                      {invoiceDateValue ? formatTime(invoiceDateValue) : '—'}
                    </Typography>
                  </TableCell>
                  <TableCell style={{ fontSize: 'clamp(0.67rem, 0.7vw, 0.8125rem)' }}>
                    {appointment ? getCourseName(appointment.treatment) : '—'}
                  </TableCell>
                  <TableCell style={{ fontSize: 'clamp(0.67rem, 0.7vw, 0.8125rem)' }}>
                    {appointment ? (appointment.title || getAppointmentLabel(appointment.appointment_type)) : '—'}
                  </TableCell>
                  <TableCell style={{ fontSize: 'clamp(0.67rem, 0.7vw, 0.8125rem)' }}>
                    {appointment?.staff_member_name || '—'}
                  </TableCell>
                  <TableCell style={{ fontSize: 'clamp(0.67rem, 0.7vw, 0.8125rem)' }}>
                    <Chip size="small" label={payerChip.label} style={payerChip.style} />
                  </TableCell>
                  <TableCell>
                    <Typography style={{ fontWeight: 600, color: '#2E7D32', fontSize: 'clamp(0.67rem, 0.7vw, 0.8125rem)' }}>
                      {invoice.currency || 'EUR'} {Number.parseFloat(invoiceDisplayAmount || 0).toFixed(2)}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Box style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                      <Button
                        onClick={() => handleViewInvoice(invoice.id)}
                        disabled={invoicePreviewLoading}
                        style={{
                          padding: 0,
                          minWidth: 0,
                          textTransform: 'none',
                          color: '#002D55',
                          fontWeight: 600,
                          fontSize: 'clamp(0.67rem, 0.7vw, 0.8125rem)',
                        }}
                      >
                        #{invoice.invoice_number || invoice.id}
                      </Button>
                      {invoice.ean_submission_status && ['delivered', 'accepted'].includes(invoice.ean_submission_status) && (
                        <Tooltip title="Sent via EAN successfully">
                          <CheckCircleIcon style={{ fontSize: 14, color: '#2E7D32' }} />
                        </Tooltip>
                      )}
                      {invoice.sent_date && (
                        <Tooltip title={invoice.email_opened ? 'Invoice viewed by patient' : 'Invoice sent — not yet viewed (may be in spam)'}>
                          <MarkunreadMailboxIcon style={{ fontSize: 14, color: invoice.email_opened ? '#1565C0' : '#9E9E9E' }} />
                        </Tooltip>
                      )}
                      <IconButton
                        size="small"
                        onClick={(event) => handleOpenInvoiceActions(event, invoice)}
                        disabled={invoiceActionsLoading}
                        style={{ color: '#002D55' }}
                      >
                        <MoreVertIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    <Chip size="small" label={statusChip.label} style={statusChip.style} />
                  </TableCell>
                  <TableCell align="center">
                    <Chip size="small" label={billingChip.label} style={billingChip.style} />
                  </TableCell>
                </TableRow>
              );
            })
          ) : (
            <TableRow>
              <TableCell colSpan={9} style={{ fontSize: '11px', padding: '10px', textAlign: 'center', color: '#999', fontStyle: 'italic' }}>
                {emptyMessage}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );

  return (
    <form
      autoComplete="off"
      noValidate
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Card className={classes.card}>
        <CardHeader
          className={classes.cardHeaderRoot}
          title={
            <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" style={{ gap: 'clamp(8px, 0.78vw, 12px)' }}>
              {headerTitle ? (
                <span className={classes.cardHeaderTitle}>{headerTitle}</span>
              ) : null}
              {headerTabs ? (
                <Box display="flex" alignItems="center">
                  {headerTabs}
                </Box>
              ) : null}
            </Box>
          }
        />
        <CardContent className={classes.cardContent}>



          {/* ── Payment Preference (Read-Only) ── */}
          <Typography className={classes.cardHeaderTitle} style={{ fontSize: 'clamp(0.88rem, 0.95vw, 1.125rem)', marginBottom: 'clamp(12px, 1.04vw, 16px)' }}>
            Payment Preference
          </Typography>
          {/* ── Payment Overview ── */}
          <Typography className={classes.bodyText}>
            Payments are securely handled by Stripe, including credit/debit cards, Apple Pay, and MobilePay.
          </Typography>
          {errorMessage ? (
            <Typography style={{ color: '#d32f2f', marginBottom: 'clamp(10px, 0.91vw, 14px)', fontSize: 'clamp(0.67rem, 0.7vw, 0.8125rem)' }}>
              {errorMessage}
            </Typography>
          ) : null}
          {invoiceActionNotice ? (
            <Typography style={{ color: '#2E7D32', marginBottom: 'clamp(10px, 0.91vw, 14px)', fontSize: 'clamp(0.67rem, 0.7vw, 0.8125rem)', fontWeight: 600 }}>
              {invoiceActionNotice}
            </Typography>
          ) : null}
          {invoiceActionError ? (
            <Typography style={{ color: '#d32f2f', marginBottom: 'clamp(10px, 0.91vw, 14px)', fontSize: 'clamp(0.67rem, 0.7vw, 0.8125rem)' }}>
              {invoiceActionError}
            </Typography>
          ) : null}
          <Box display="flex" alignItems="center" flexWrap="wrap" style={{ gap: 'clamp(24px, 2vw, 32px)', marginBottom: 'clamp(6px, 0.52vw, 8px)' }}>
            <Chip
              label={hasMethods ? 'Card on file' : 'No card on file'}
              className={hasMethods ? classes.statusChipActive : classes.statusChip}
              size="small"
              style={{ marginTop: 0 }}
            />
            {loadingPref ? (
              <CircularProgress size={20} />
            ) : (
              <FormControl component="fieldset" disabled>
                <RadioGroup row value={paymentPreference}>
                  <FormControlLabel
                    value="auto"
                    control={<Radio style={{ color: paymentPreference === 'auto' ? '#FF7F27' : '#002D55' }} />}
                    label="Auto-pay (charge saved card when invoices are issued)"
                  />
                  <FormControlLabel
                    value="invoice"
                    control={<Radio style={{ color: paymentPreference === 'invoice' ? '#FF7F27' : '#002D55' }} />}
                    label="Manual payment (receive invoices)"
                  />
                </RadioGroup>
              </FormControl>
            )}
          </Box>

          {/* ── Request Autopay Button ── */}
          {paymentPreference !== 'auto' && (
            <Box style={{ marginTop: 'clamp(12px, 1.04vw, 16px)' }}>
              <Button
                variant="contained"
                className={classes.Button}
                size="small"
                onClick={() => setRequestAutopayDialogOpen(true)}
              >
                Request Autopay from Patient
              </Button>
              <Typography style={{ fontSize: 'clamp(0.625rem, 0.65vw, 0.75rem)', color: '#666', marginTop: 'clamp(6px, 0.52vw, 8px)', fontStyle: 'italic' }}>
                Send a notification request to patient to enable autopay for future invoices.
              </Typography>
            </Box>
          )}

          <Divider style={{ marginTop: 'clamp(18px, 1.56vw, 24px)', marginBottom: 'clamp(18px, 1.56vw, 24px)' }} />

          {/* ── Challenged Invoices Alert ── */}
          {challengedInvoices.length > 0 && (
            <Box style={{ marginBottom: 'clamp(12px, 1.04vw, 16px)', padding: 'clamp(8px, 0.78vw, 12px)', backgroundColor: '#FFF3E0', borderRadius: 8, border: '2px solid #F57C00' }}>
              <Typography style={{ fontSize: 'clamp(0.72rem, 0.76vw, 0.875rem)', color: '#E65100', fontWeight: 700, marginBottom: 'clamp(6px, 0.52vw, 8px)' }}>
                ⚠️ {challengedInvoices.length} Invoice{challengedInvoices.length > 1 ? 's' : ''} Challenged by Patient
              </Typography>
              {challengedInvoices.map((inv) => (
                <Box key={inv.id} style={{ marginBottom: 'clamp(6px, 0.52vw, 8px)', paddingBottom: 'clamp(6px, 0.52vw, 8px)', borderBottom: '1px solid #FFE0B2' }}>
                  <Typography style={{ fontSize: 'clamp(0.67rem, 0.7vw, 0.8125rem)', color: '#333', fontWeight: 600 }}>
                    Invoice #{inv.invoice_number || inv.id}
                  </Typography>
                  <Typography style={{ fontSize: 'clamp(0.625rem, 0.65vw, 0.75rem)', color: '#666', marginTop: 'clamp(3px, 0.26vw, 4px)' }}>
                    Reason: {inv.challenge_reason || 'No reason provided'}
                  </Typography>
                  <Typography style={{ fontSize: 'clamp(0.58rem, 0.6vw, 0.6875rem)', color: '#999', marginTop: 2 }}>
                    Challenged on: {inv.challenged_at ? new Date(inv.challenged_at).toLocaleDateString() : 'N/A'}
                  </Typography>
                </Box>
              ))}
            </Box>
          )}

          {/* ── Appointment Billing Status ── */}
          <Typography className={classes.cardHeaderTitle} style={{ fontSize: 'clamp(0.88rem, 0.95vw, 1.125rem)', marginBottom: 'clamp(12px, 1.04vw, 16px)' }}>
            Appointment Billing History
          </Typography>
          {loadingData ? (
            <Box display="flex" justifyContent="center" padding={3}>
              <CircularProgress />
            </Box>
          ) : appointments.length === 0 ? (
            <Typography style={{ color: '#999', fontStyle: 'italic', padding: 'clamp(8px, 0.78vw, 12px) 0' }}>
              No appointments found.
            </Typography>
          ) : (
            <>
              <Box style={{ display: 'flex', gap: 'clamp(8px, 1vw, 12px)', marginBottom: 'clamp(10px, 1.3vw, 16px)' }}>
                <Box style={{ flex: 1, textAlign: 'center', padding: 'clamp(8px, 1.2vw, 12px)', backgroundColor: '#E8F5E9', borderRadius: 8 }}>
                  <Typography style={{ fontWeight: 600, color: '#2E7D32' }}>Paid</Typography>
                  <Typography style={{ fontSize: 'clamp(1rem, 2vw, 1.25rem)', fontWeight: 'bold', color: '#2E7D32' }}>{paidCount}</Typography>
                </Box>
                <Box style={{ flex: 1, textAlign: 'center', padding: 'clamp(8px, 1.2vw, 12px)', backgroundColor: '#FFF3E0', borderRadius: 8 }}>
                  <Typography style={{ fontWeight: 600, color: '#F57C00' }}>Unpaid</Typography>
                  <Typography style={{ fontSize: 'clamp(1rem, 2vw, 1.25rem)', fontWeight: 'bold', color: '#F57C00' }}>{unpaidCount}</Typography>
                </Box>
              </Box>

              <Box
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: 'clamp(8px, 0.78vw, 12px)',
                  marginBottom: 'clamp(12px, 1.04vw, 16px)',
                  padding: 'clamp(10px, 0.91vw, 14px)',
                  backgroundColor: '#F5F9FF',
                  border: '1px solid #DCE8F5',
                  borderRadius: 10,
                }}
              >
                <Typography style={{ fontSize: 'clamp(0.72rem, 0.76vw, 0.875rem)', color: '#002D55', fontWeight: 600 }}>
                  Unbilled past appointments: {billablePastAppointments.length}
                  {selectedBillableAppointmentIds.length > 0 ? ` | Selected: ${selectedBillableAppointmentIds.length}` : ''}
                </Typography>
                <Box style={{ display: 'flex', flexWrap: 'wrap', gap: 8, justifyContent: 'flex-end' }}>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={handleToggleSelectAllUnbilled}
                    disabled={billablePastAppointmentIds.length === 0}
                    style={{ borderColor: '#002D55', color: '#002D55', textTransform: 'none' }}
                  >
                    {selectedBillableAppointmentIds.length === billablePastAppointmentIds.length && billablePastAppointmentIds.length > 0 ? 'Clear all' : 'Select all unbilled'}
                  </Button>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() => setSelectedBillingRows([])}
                    disabled={selectedBillableAppointmentIds.length === 0}
                    style={{ borderColor: '#64748B', color: '#64748B', textTransform: 'none' }}
                  >
                    Clear selection
                  </Button>
                  <Button
                    size="small"
                    variant="contained"
                    onClick={handleBillSelectedAppointments}
                    disabled={selectedBillableAppointmentIds.length === 0}
                    className={classes.Button}
                  >
                    Bill selected
                  </Button>
                  <Button
                    size="small"
                    variant="contained"
                    onClick={handleBillAllUnbilledAppointments}
                    disabled={billablePastAppointmentIds.length === 0}
                    className={classes.Button}
                  >
                    Bill all unbilled
                  </Button>
                </Box>
              </Box>

              {/* Past Appointments - Grouped by Month */}
              {pastAppointments.length > 0 && (
                <Box>
                  <Typography style={{ fontWeight: 600, color: '#002D55', marginBottom: 'clamp(6px, 0.52vw, 8px)' }}>
                    Past Appointments ({pastAppointments.length})
                  </Typography>
                  {pastAppointmentsByMonth.map((monthGroup, monthIdx) => (
                    <Accordion key={monthGroup.key} defaultExpanded={monthIdx === 0} style={{ marginBottom: 'clamp(6px, 0.52vw, 8px)', borderRadius: 8, overflow: 'hidden' }}>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: '#f5f5f5' }}>
                        <Typography style={{ fontWeight: 600, color: '#002D55' }}>
                          {monthGroup.monthName} ({monthGroup.items.length} appointments)
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails style={{ padding: 0 }}>
                        <TableContainer>
                          <Table size="small">
                            <TableHead>
                              <TableRow style={{ backgroundColor: "#F0F8FF" }}>
                                <TableCell style={{ fontWeight: 600, color: '#002D55' }}>Bill</TableCell>
                                <TableCell style={{ fontWeight: 600, color: '#002D55' }}>Date & Time</TableCell>
                                <TableCell style={{ fontWeight: 600, color: '#002D55' }}>Course</TableCell>
                                <TableCell style={{ fontWeight: 600, color: '#002D55' }}>Service</TableCell>
                                <TableCell style={{ fontWeight: 600, color: '#002D55' }}>Staff</TableCell>
                                <TableCell style={{ fontWeight: 600, color: '#002D55' }}>Payer</TableCell>
                                <TableCell style={{ fontWeight: 600, color: '#002D55' }}>Amount</TableCell>
                                <TableCell style={{ fontWeight: 600, color: '#002D55' }}>Invoice</TableCell>
                                <TableCell style={{ fontWeight: 600, color: '#002D55' }} align="center">Status</TableCell>
                                <TableCell style={{ fontWeight: 600, color: '#002D55' }} align="center">Payment</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {monthGroup.items.map((appt) => {
                                const primaryInvoice = getAppointmentInvoice(appt.id);
                                const statusChip = getAppointmentStatusChip(appt);
                                const canBillAppointment = String(appt.billing_status || '').toLowerCase() === 'unbilled';
                                const isSelectedForBilling = selectedBillingRows.some((appointmentId) => String(appointmentId) === String(appt.id));
                                return (
                                  <TableRow
                                    key={appt.id}
                                    style={{
                                      borderLeft: isAppointmentPaid(appt, primaryInvoice) ? '3px solid #4CAF50' : '3px solid #FFC107'
                                    }}
                                  >
                                    <TableCell>
                                      <Checkbox
                                        color="primary"
                                        checked={isSelectedForBilling}
                                        disabled={!canBillAppointment}
                                        onChange={() => handleToggleBillingRowSelected(appt.id)}
                                      />
                                    </TableCell>
                                    <TableCell>
                                      <Typography style={{ fontWeight: 600, fontSize: 'clamp(0.72rem, 0.76vw, 0.875rem)' }}>
                                        {formatDate(appt.start_datetime)}
                                      </Typography>
                                      <Typography style={{ fontSize: 'clamp(0.625rem, 0.65vw, 0.75rem)', color: '#666' }}>
                                        {formatTime(appt.start_datetime)}
                                      </Typography>
                                    </TableCell>
                                    <TableCell style={{ fontSize: 'clamp(0.67rem, 0.7vw, 0.8125rem)' }}>{getCourseName(appt.treatment)}</TableCell>
                                    <TableCell style={{ fontSize: 'clamp(0.67rem, 0.7vw, 0.8125rem)' }}>{appt.title || getAppointmentLabel(appt.appointment_type)}</TableCell>
                                    <TableCell style={{ fontSize: 'clamp(0.67rem, 0.7vw, 0.8125rem)' }}>{appt.staff_member_name || '—'}</TableCell>
                                    <TableCell style={{ fontSize: 'clamp(0.67rem, 0.7vw, 0.8125rem)' }}>
                                      {appt.payer_type === 'insurance' ? (
                                        <Box>
                                          <Typography style={{ fontSize: 'clamp(0.625rem, 0.65vw, 0.75rem)', fontWeight: 600, color: '#FF7F27' }}>
                                            Insurance
                                          </Typography>
                                          <Typography style={{ fontSize: 'clamp(0.58rem, 0.6vw, 0.6875rem)', color: '#666666' }}>
                                            {appt.payer_referral_letter ? appt.payer_referral_letter : '(No referral)'}
                                          </Typography>
                                        </Box>
                                      ) : (
                                        <Typography style={{ fontSize: 'clamp(0.625rem, 0.65vw, 0.75rem)', color: '#666666' }}>
                                          Patient
                                        </Typography>
                                      )}
                                    </TableCell>
                                    <TableCell style={{ fontSize: 'clamp(0.67rem, 0.7vw, 0.8125rem)' }}>
                                      <Box>
                                        {appt.payer_type === 'insurance' && (appt.insurance_covered_amount !== null && appt.insurance_covered_amount !== undefined) ? (
                                          <>
                                            <Typography style={{ fontSize: 'clamp(0.625rem, 0.65vw, 0.75rem)', fontWeight: 600, color: '#002D55' }}>
                                              {appt.booked_currency || 'EUR'} {Number(appt.insurance_covered_amount || 0).toFixed(2)}
                                            </Typography>
                                            {appt.patient_out_of_pocket_amount && Number(appt.patient_out_of_pocket_amount) > 0 && (
                                              <Typography style={{ fontSize: 'clamp(0.58rem, 0.6vw, 0.6875rem)', color: '#666666', marginTop: 2 }}>
                                                + {appt.booked_currency || 'EUR'} {Number(appt.patient_out_of_pocket_amount).toFixed(2)} (Patient)
                                              </Typography>
                                            )}
                                          </>
                                        ) : (
                                          <Typography style={{ fontSize: 'clamp(0.625rem, 0.65vw, 0.75rem)', color: '#002D55' }}>
                                            {appt.booked_currency || 'EUR'} {appt.booked_price || '0.00'}
                                          </Typography>
                                        )}
                                      </Box>
                                    </TableCell>
                                    <TableCell>
                                      {primaryInvoice ? (
                                        <Button
                                          size="small"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleViewInvoice(primaryInvoice.id);
                                          }}
                                          disabled={invoicePreviewLoading}
                                          style={{
                                            padding: 0,
                                            minWidth: 0,
                                            textTransform: 'none',
                                            color: '#002D55',
                                            fontWeight: 600,
                                          }}
                                        >
                                          #{primaryInvoice.invoice_number}
                                        </Button>
                                      ) : (
                                        <Typography style={{ fontSize: 'clamp(0.625rem, 0.65vw, 0.75rem)', color: '#999', fontStyle: 'italic' }}>
                                          Not invoiced
                                        </Typography>
                                      )}
                                    </TableCell>
                                    <TableCell align="center">
                                      <Chip
                                        size="small"
                                        label={statusChip.label}
                                        style={statusChip.style}
                                      />
                                    </TableCell>
                                    <TableCell align="center">
                                      {(() => {
                                        const chip = getAppointmentBillingChip(appt, primaryInvoice);
                                        return (
                                          <Chip
                                            size="small"
                                            label={chip.label}
                                            style={chip.style}
                                          />
                                        );
                                      })()}
                                    </TableCell>
                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </Box>
              )}
            </>
          )}

          <Divider style={{ marginTop: 'clamp(18px, 1.56vw, 24px)', marginBottom: 'clamp(18px, 1.56vw, 24px)' }} />

          {/* ── Unpaid Invoices (Read-Only) ── */}
          <Typography className={classes.cardHeaderTitle} style={{ fontSize: 'clamp(0.88rem, 0.95vw, 1.125rem)', marginBottom: 'clamp(12px, 1.04vw, 16px)' }}>
            Unpaid Invoices
          </Typography>
          {loadingData ? (
            <CircularProgress size={20} />
          ) : unpaidInvoices.length === 0 ? (
            <Typography style={{ color: '#999', fontStyle: 'italic' }}>
              No unpaid invoices.
            </Typography>
          ) : (
            renderInvoiceStatsTable(unpaidInvoices, 'No unpaid invoices.', '#FFC107')
          )}

          <Divider style={{ marginTop: 'clamp(18px, 1.56vw, 24px)', marginBottom: 'clamp(18px, 1.56vw, 24px)' }} />

          {/* ── Paid Invoices ── */}
          <Typography className={classes.cardHeaderTitle} style={{ fontSize: 'clamp(0.88rem, 0.95vw, 1.125rem)', marginBottom: 'clamp(12px, 1.04vw, 16px)' }}>
            Paid Invoices
          </Typography>
          {loadingData ? (
            <CircularProgress size={20} />
          ) : paidInvoices.length === 0 ? (
            <Typography style={{ color: '#999', fontStyle: 'italic' }}>
              No paid invoices yet.
            </Typography>
          ) : (
            <Box>
              {paidInvoicesByMonth.map((monthGroup, monthIdx) => (
                <Accordion key={monthGroup.key} defaultExpanded={monthIdx === 0} style={{ marginBottom: 'clamp(8px, 0.78vw, 12px)', borderRadius: 8, overflow: 'hidden' }}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: '#f5f5f5' }}>
                    <Typography style={{ fontWeight: 600, color: '#002D55' }}>
                      {monthGroup.monthName} ({monthGroup.items.length} invoices)
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails style={{ padding: 0 }}>
                    {renderInvoiceStatsTable(monthGroup.items, 'No paid invoices in this month.', '#4CAF50')}
                  </AccordionDetails>
                </Accordion>
              ))}
            </Box>
          )}

          <Divider style={{ marginTop: 'clamp(18px, 1.56vw, 24px)', marginBottom: 'clamp(18px, 1.56vw, 24px)' }} />

          {/* ── Per-Treatment-Course Billing Tracker ── */}
          {(() => {
            const courseMap = {};
            appointments.forEach((appt) => {
              if (!appt.treatment) return;
              const key = String(appt.treatment);
              if (!courseMap[key]) {
                courseMap[key] = {
                  treatmentId: key,
                  courseName: getCourseName(appt.treatment),
                  total: 0,
                  paidTotal: 0,
                  unpaidTotal: 0,
                  count: 0,
                  paidCount: 0,
                  services: new Set(),
                };
              }
              const inv = getAppointmentInvoice(appt.id);
              const amount = parseFloat(appt.booked_price || 0);
              courseMap[key].total += amount;
              courseMap[key].count += 1;
              courseMap[key].services.add(appt.title || getAppointmentLabel(appt.appointment_type) || 'Appointment');
              if (inv && inv.status === 'paid') {
                courseMap[key].paidTotal += amount;
                courseMap[key].paidCount += 1;
              } else if (inv && isOpenInvoice(inv)) {
                courseMap[key].unpaidTotal += amount;
              }
            });
            const courses = Object.values(courseMap);
            if (courses.length === 0) return null;
            return (
              <>
                <Typography className={classes.cardHeaderTitle} style={{ fontSize: 'clamp(0.88rem, 0.95vw, 1.125rem)', marginBottom: 'clamp(12px, 1.04vw, 16px)' }}>
                  Billed by Treatment Course
                </Typography>
                <TableContainer component={Paper} elevation={0} style={{ borderRadius: 8, marginBottom: 'clamp(12px, 1.04vw, 16px)' }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow style={{ backgroundColor: '#F0F8FF' }}>
                        <TableCell style={{ fontWeight: 600, color: '#002D55', fontSize: 'clamp(0.67rem, 0.7vw, 0.8125rem)' }}>Treatment Course</TableCell>
                        <TableCell style={{ fontWeight: 600, color: '#002D55', fontSize: 'clamp(0.67rem, 0.7vw, 0.8125rem)' }}>Services</TableCell>
                        <TableCell style={{ fontWeight: 600, color: '#002D55', fontSize: 'clamp(0.67rem, 0.7vw, 0.8125rem)' }} align="right">Appointments</TableCell>
                        <TableCell style={{ fontWeight: 600, color: '#002D55', fontSize: 'clamp(0.67rem, 0.7vw, 0.8125rem)' }} align="right">Total Billed</TableCell>
                        <TableCell style={{ fontWeight: 600, color: '#002D55', fontSize: 'clamp(0.67rem, 0.7vw, 0.8125rem)' }} align="right">Paid</TableCell>
                        <TableCell style={{ fontWeight: 600, color: '#002D55', fontSize: 'clamp(0.67rem, 0.7vw, 0.8125rem)' }} align="right">Outstanding</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {courses.map((course) => (
                        <TableRow key={course.treatmentId} style={{ borderLeft: '3px solid #002D55' }}>
                          <TableCell style={{ fontWeight: 600, fontSize: 'clamp(0.67rem, 0.7vw, 0.8125rem)', color: '#002D55' }}>
                            {course.courseName}
                          </TableCell>
                          <TableCell style={{ fontSize: 'clamp(0.625rem, 0.65vw, 0.75rem)', color: '#666' }}>
                            {[...course.services].join(', ') || '—'}
                          </TableCell>
                          <TableCell align="right" style={{ fontSize: 'clamp(0.67rem, 0.7vw, 0.8125rem)' }}>
                            {course.count}
                            {course.paidCount > 0 && (
                              <Typography style={{ fontSize: 'clamp(0.58rem, 0.6vw, 0.6875rem)', color: '#2E7D32' }}>
                                {course.paidCount} paid
                              </Typography>
                            )}
                          </TableCell>
                          <TableCell align="right" style={{ fontWeight: 600, fontSize: 'clamp(0.67rem, 0.7vw, 0.8125rem)' }}>
                            EUR {course.total.toFixed(2)}
                          </TableCell>
                          <TableCell align="right" style={{ fontSize: 'clamp(0.67rem, 0.7vw, 0.8125rem)', color: '#2E7D32' }}>
                            EUR {course.paidTotal.toFixed(2)}
                          </TableCell>
                          <TableCell align="right" style={{ fontSize: 'clamp(0.67rem, 0.7vw, 0.8125rem)', color: course.unpaidTotal > 0 ? '#F57C00' : '#999' }}>
                            EUR {course.unpaidTotal.toFixed(2)}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            );
          })()}

          <Divider style={{ marginTop: 'clamp(18px, 1.56vw, 24px)', marginBottom: 'clamp(18px, 1.56vw, 24px)' }} />

          {/* ── Billing Portal (Admin's Own) ── */}
          <Typography className={classes.cardHeaderTitle} style={{ fontSize: 'clamp(0.88rem, 0.95vw, 1.125rem)', marginBottom: 'clamp(12px, 1.04vw, 16px)' }}>
            Billing Portal
          </Typography>
          <Typography className={classes.bodyText}>
            Manage your own billing details and view full history in the Stripe Billing Portal.
          </Typography>
          <Divider style={{ margin: 'clamp(16px, 1.3vw, 20px) 0' }} />
          <Button
            className={classes.Button}
            variant="contained"
            fullWidth
            onClick={handleBillingPortal}
            style={{ marginTop: 'clamp(8px, 0.78vw, 12px)' }}
          >
            Open My Billing Portal (Admin)
          </Button>

        </CardContent>
      </Card>

      <Dialog
        open={billDialogOpen}
        onClose={() => !billDialogLoading && setBillDialogOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{ className: classes.dialogPaper }}
      >
        <DialogTitle className={classes.dialogTitle}>
          <Box className={classes.dialogTitleRow}>
            <Typography className={classes.dialogTitleText}>Bill Unbilled Past Appointments</Typography>
            <IconButton
              aria-label="close"
              onClick={() => setBillDialogOpen(false)}
              size="small"
              className={classes.closeButton}
              disabled={billDialogLoading}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <Paper elevation={0} className={classes.dialogPanel}>
            <Typography className={classes.dialogSectionLabel}>Invoice Setup</Typography>
            <Typography style={{ marginBottom: 12, fontSize: 14, color: '#333' }}>
              Selected appointments: {selectedBillableAppointmentIds.length}
            </Typography>
            <TextField
              label="Billing Mode"
              select
              value={billingGroupMode}
              onChange={(e) => setBillingGroupMode(e.target.value)}
              variant="outlined"
              size="small"
              fullWidth
              className={classes.orangeFocused}
              style={{ marginBottom: 12 }}
              SelectProps={{ MenuProps: SELECT_MENU_PROPS }}
            >
              <MenuItem value="group_by_payer">All selected appointments in one invoice</MenuItem>
              <MenuItem value="single">Separate invoice per appointment</MenuItem>
            </TextField>
            <Typography style={{ fontSize: 12, color: '#666' }}>
              All-in-one billing groups selected appointments by payer. Separate billing creates one invoice per appointment.
            </Typography>
            {billDialogError && (
              <Typography color="error" style={{ marginTop: 12, fontSize: 12 }}>
                {billDialogError}
              </Typography>
            )}
          </Paper>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button
            onClick={() => setBillDialogOpen(false)}
            className={clsx(classes.Button3, classes.dialogActionButton)}
            disabled={billDialogLoading}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            className={clsx(classes.Button, classes.dialogActionButton)}
            onClick={handleConfirmBillSelectedAppointments}
            disabled={billDialogLoading || selectedBillableAppointmentIds.length === 0}
          >
            Preview Invoices
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={billPreviewOpen}
        onClose={() => !billPreviewLoading && setBillPreviewOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{ className: classes.dialogPaper }}
      >
        <DialogTitle className={classes.dialogTitle}>
          <Box className={classes.dialogTitleRow}>
            <Typography className={classes.dialogTitleText}>
              Preview Invoices Before Billing
            </Typography>
            <IconButton
              aria-label="close"
              onClick={() => setBillPreviewOpen(false)}
              size="small"
              className={classes.closeButton}
              disabled={billPreviewLoading}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers style={{ padding: 0, backgroundColor: '#F8F9FA' }}>
          {billPreviewInvoices.length === 0 ? (
            <Box style={{ padding: 32, textAlign: 'center' }}>
              <Typography style={{ color: '#999' }}>No invoices to preview.</Typography>
            </Box>
          ) : (
            billPreviewInvoices.map((group, idx) => {
              const currency = group.rows[0]?.booked_currency || 'EUR';
              const today = new Date().toISOString().split('T')[0];
              const due = new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
              const syntheticInvoice = {
                invoice_number: 'PREVIEW',
                invoice_date: today,
                due_date: due,
                currency,
                recipient_type: group.payer === 'insurance' ? 'insurance' : 'patient',
                insurer_name: null,
                insurer_ean: null,
                patient_portion_amount: group.patientPortion,
                insurance_portion_amount: group.insurancePortion,
                total_amount: group.total,
                line_items: group.rows.map((appt) => ({
                  appointment_date: appt.start_datetime,
                  service_code: appt.service_code || appt.service?.service_code || '',
                  service_name: appt.title || getAppointmentLabel(appt.appointment_type) || 'Appointment',
                  description: appt.start_datetime ? formatDate(appt.start_datetime) : '—',
                  unit_price: appt.resolvedTotal || 0,
                  patient_portion: appt.resolvedPatientPortion || 0,
                  insurance_portion: appt.resolvedInsurancePortion || 0,
                })),
              };
              return (
                <Box
                  key={idx}
                  style={{
                    borderBottom: idx < billPreviewInvoices.length - 1 ? '2px dashed #E0E0E0' : 'none',
                  }}
                >
                  <InvoicePrintableContent
                    domId={`bill-preview-invoice-${idx}`}
                    invoice={syntheticInvoice}
                    issuerName={careProviderInfo?.name_business || 'Clinic'}
                    clinic={{
                      address: cpAddress,
                      postalCode: cpPostalCode,
                      city: cpCity,
                      cvr: careProviderInfo?.business_registration_number || '',
                      bankAccount: '',
                      phone: cpPhone,
                      email: cpEmail,
                    }}
                    patient={{
                      name: group.patient,
                      address: selectedPatient?.address || selectedPatient?.user?.address || '',
                      postalCode: selectedPatient?.postal_code || selectedPatient?.zip || '',
                      city: selectedPatient?.city || '',
                      email: selectedPatient?.email || selectedPatient?.user?.email || '',
                    }}
                  />
                </Box>
              );
            })
          )}
          {billDialogError && (
            <Box style={{ padding: '8px 24px' }}>
              <Typography color="error" style={{ fontSize: 12 }}>{billDialogError}</Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button
            onClick={() => { setBillPreviewOpen(false); setBillDialogOpen(true); }}
            className={clsx(classes.Button3, classes.dialogActionButton)}
            disabled={billPreviewLoading}
          >
            Back
          </Button>
          <Button
            variant="contained"
            className={clsx(classes.Button, classes.dialogActionButton)}
            onClick={handleConfirmBillAfterPreview}
            disabled={billPreviewLoading}
          >
            {billPreviewLoading ? 'Billing...' : `Confirm & Bill ${selectedBillableAppointmentIds.length} Appointment${selectedBillableAppointmentIds.length === 1 ? '' : 's'}`}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={invoicePreviewOpen}
        onClose={() => setInvoicePreviewOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{ className: classes.dialogPaper }}
      >
        <DialogTitle className={classes.dialogTitle}>
          <Box className={classes.dialogTitleRow}>
            <Typography className={classes.dialogTitleText}>
              Invoice Details
            </Typography>
            <IconButton onClick={() => setInvoicePreviewOpen(false)} size="small" className={classes.closeButton}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers className={clsx(classes.dialogContent, classes.dialogContentFlush)}>
          {selectedInvoiceForPreview && (
            <InvoicePrintableContent
              invoice={selectedInvoiceForPreview}
              issuerName={careProviderInfo?.name_business || getInvoiceIssuerName(selectedInvoiceForPreview) || 'VIRTUS PHYSIO'}
              issuerSelector={
                String(selectedInvoiceForPreview.billing_type || '').toLowerCase() === 'staff_subcontractor' ? (
                  <Box style={{ marginBottom: '16px', display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
                    <TextField
                      select
                      label="Subcontractor Invoice Name"
                      variant="outlined"
                      size="small"
                      value={invoiceIssuerNameMode}
                      onChange={(e) => setInvoiceIssuerNameMode(e.target.value)}
                      style={{ minWidth: 240 }}
                    >
                      <MenuItem value="staff">Use Staff Name</MenuItem>
                      <MenuItem value="clinic">Use Clinic Name</MenuItem>
                      <MenuItem value="custom">Use Custom Business Name</MenuItem>
                    </TextField>
                    {invoiceIssuerNameMode === 'custom' && (
                      <TextField
                        label="Custom Business Name"
                        variant="outlined"
                        size="small"
                        value={invoiceCustomIssuerName}
                        onChange={(e) => setInvoiceCustomIssuerName(e.target.value)}
                        style={{ minWidth: 280 }}
                      />
                    )}
                  </Box>
                ) : null
              }
              clinic={{
                address: cpAddress,
                postalCode: cpPostalCode,
                city: cpCity,
                cvr: careProviderInfo?.business_registration_number || '',
                bankAccount: '',
                phone: cpPhone,
                email: cpEmail,
              }}
              patient={{
                name: selectedInvoiceForPreview?.patient?.name
                  || [selectedInvoiceForPreview?.patient?.user?.first_name, selectedInvoiceForPreview?.patient?.user?.last_name].filter(Boolean).join(' ').trim()
                  || selectedInvoiceForPreview?.patient?.user?.full_name
                  || selectedPatient?.name
                  || [selectedPatient?.user?.first_name, selectedPatient?.user?.last_name].filter(Boolean).join(' ').trim(),
                address: selectedInvoiceForPreview?.patient?.address || selectedPatient?.address || selectedPatient?.user?.address || '',
                postalCode: selectedInvoiceForPreview?.patient?.zip || selectedInvoiceForPreview?.patient?.postal_code || selectedPatient?.zip || selectedPatient?.postal_code || '',
                city: selectedInvoiceForPreview?.patient?.city || selectedPatient?.city || '',
                email: selectedInvoiceForPreview?.patient?.email || selectedPatient?.email || selectedPatient?.user?.email || '',
              }}
            />
          )}
        </DialogContent>
        <DialogActions style={{ padding: '16px 24px', backgroundColor: '#ffffff', borderTop: '1px solid #eeeeee', gap: 8, justifyContent: 'flex-end' }}>
          <Button
            onClick={() => setInvoicePreviewOpen(false)}
            className={classes.closeIconButton}
            style={{ borderRadius: 18, padding: '6px 16px', fontWeight: 600 }}
          >
            Close
          </Button>
          <Button
            onClick={handleDownloadInvoicePDF}
            variant="contained"
            startIcon={<GetAppIcon />}
            className={clsx(classes.Button, classes.downloadButton)}
          >
            Download PDF
          </Button>
        </DialogActions>
      </Dialog>

      <Menu
        anchorEl={invoiceActionsAnchorEl}
        open={Boolean(invoiceActionsAnchorEl)}
        onClose={handleCloseInvoiceActions}
      >
        <MenuItem
          onClick={() => {
            const invoiceId = invoiceActionsInvoice?.id;
            handleCloseInvoiceActions();
            if (invoiceId) {
              handleViewInvoice(invoiceId);
            }
          }}
        >
          <VisibilityIcon fontSize="small" style={{ marginRight: 8, color: '#002D55' }} />
          View Invoice
        </MenuItem>
        <MenuItem
          onClick={() => handleInvoiceBulkAction('send_reminder')}
          disabled={invoiceActionsLoading}
        >
          <NotificationsActiveIcon fontSize="small" style={{ marginRight: 8, color: '#FF9800' }} />
          {(() => {
            const reminderType = getNextReminderTypeForInvoice(invoiceActionsInvoice);
            return reminderType === 'inkasso' ? 'Send Inkasso' : `Send ${reminderType} Reminder`;
          })()}
        </MenuItem>
        <MenuItem
          onClick={() => handleInvoiceBulkAction('accredit')}
          disabled={invoiceActionsLoading || !isAccreditableInvoice(invoiceActionsInvoice)}
        >
          <ReceiptIcon fontSize="small" style={{ marginRight: 8, color: '#4CAF50' }} />
          Accredit
        </MenuItem>
      </Menu>

      {/* ─── Request Autopay Confirmation Dialog ── */}
      <Dialog
        open={requestAutopayDialogOpen}
        onClose={() => !requestingAutopay && setRequestAutopayDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ backgroundColor: '#FF7F27', color: '#fff', fontWeight: 600 }}>
          Request Autopay from Patient
        </DialogTitle>
        <DialogContent style={{ padding: 'clamp(14px, 2.1vw, 24px)', backgroundColor: '#f7faff' }}>
          {autopayRequestMessage === 'success' ? (
            <Box style={{ textAlign: 'center', padding: 'clamp(12px, 1.04vw, 16px) 0' }}>
              <Typography style={{ fontSize: 'clamp(0.80rem, calc(4px + 0.722vw), 1.0rem)', fontWeight: 600, color: '#2E7D32', marginBottom: 'clamp(6px, 0.52vw, 8px)' }}>
                ✓ Request Sent Successfully
              </Typography>
              <Typography style={{ fontSize: 'clamp(0.72rem, 0.76vw, 0.875rem)', color: '#666' }}>
                The patient will receive a notification in their dashboard with a request to enable autopay.
              </Typography>
            </Box>
          ) : autopayRequestMessage.startsWith('error') ? (
            <Box style={{ padding: 'clamp(12px, 1.04vw, 16px)', backgroundColor: '#FFEBEE', borderRadius: 8, border: '1px solid #FFCDD2' }}>
              <Typography style={{ fontSize: 'clamp(0.67rem, 0.7vw, 0.8125rem)', color: '#C62828', fontWeight: 600 }}>
                ✗ Error
              </Typography>
              <Typography style={{ fontSize: 'clamp(0.625rem, 0.65vw, 0.75rem)', color: '#666', marginTop: 'clamp(6px, 0.52vw, 8px)' }}>
                {autopayRequestMessage.replace('error: ', '')}
              </Typography>
            </Box>
          ) : (
            <Box>
              <Typography style={{ fontSize: 'clamp(0.72rem, 0.76vw, 0.875rem)', color: '#333', marginBottom: 'clamp(12px, 1.04vw, 16px)' }}>
                Are you sure you want to send an autopay request notification to this patient?
              </Typography>
              <Typography style={{ fontSize: 'clamp(0.625rem, 0.65vw, 0.75rem)', color: '#666', marginBottom: 'clamp(8px, 0.78vw, 12px)' }}>
                The patient will receive a notification in their dashboard. They can:
              </Typography>
              <ul style={{ fontSize: 'clamp(0.625rem, 0.65vw, 0.75rem)', color: '#666', marginLeft: 'clamp(12px, 1.04vw, 16px)', marginBottom: 0 }}>
                <li>View the request on their dashboard</li>
                <li>Navigate to Payment Settings via the notification</li>
                <li>Accept or decline enabling autopay</li>
              </ul>
            </Box>
          )}
        </DialogContent>
        <DialogActions style={{ padding: 'clamp(12px, 1.04vw, 16px) clamp(18px, 1.56vw, 24px)', backgroundColor: '#f7faff' }}>
          <Button
            onClick={() => setRequestAutopayDialogOpen(false)}
            disabled={requestingAutopay}
            variant="outlined"
            style={{ borderColor: '#002D55', color: '#002D55', textTransform: 'none' }}
          >
            Cancel
          </Button>
          {!autopayRequestMessage && (
            <Button
              onClick={handleRequestAutopay}
              disabled={requestingAutopay}
              variant="contained"
              style={{ backgroundColor: '#FF7F27', color: '#FFFFFF', textTransform: 'none' }}
            >
              {requestingAutopay ? 'Sending...' : 'Send Request'}
            </Button>
          )}
          {autopayRequestMessage && (
            <Button
              onClick={() => setRequestAutopayDialogOpen(false)}
              variant="contained"
              style={{ backgroundColor: '#002D55', color: '#FFFFFF', textTransform: 'none' }}
            >
              Close
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </form>
  );
};

PaymentSubscription.propTypes = {
  className: PropTypes.string,
  selectedPatient: PropTypes.object,
  headerTabs: PropTypes.node,
  headerTitle: PropTypes.node
};

export default PaymentSubscription;